import { ACCOUNT_TYPE } from '../../constants';

/**
 * 是否商家账号访问流程
 * @param origin
 * @returns
 */
export const isBiz = (origin: string) =>
  /^(https?:\/\/)?(\w+-\w+-sl-)?peixun\.(test|cap|meituan)/.test(origin);

/**
 * 是否B端账号类型
 * @param accountType
 * @returns
 */
export const IS_B_BIZ = (accountType: ACCOUNT_TYPE) => accountType === ACCOUNT_TYPE.EPASSPORT;
